(() => {
  const initialise = (root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const mainImage = root.querySelector('#ProductMainImage');
    const thumbs = [...root.querySelectorAll('[data-product-thumb]')];
    thumbs.forEach((thumb) => {
      if (!thumb.dataset.thumbSrc) return;
      const image = new Image();
      image.src = thumb.dataset.thumbSrc;
    });
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      if (!mainImage || thumb.classList.contains('is-active')) return;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = thumb.dataset.thumbSrc;
      mainImage.alt = thumb.dataset.thumbAlt || '';
      thumbs.forEach((item) => {
        const active = item === thumb;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }));
    const variantSelect = root.querySelector('.product-redesign__variant-select');
    const sku = root.querySelector('[data-product-sku]');
    const barcode = root.querySelector('[data-product-barcode]');
    const wholesalePrice = root.querySelector('[data-product-wholesale-price]');
    const stock = root.querySelector('[data-product-stock]');
    if (variantSelect) variantSelect.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      const updateMeta = (element, value, label) => {
        if (!element) return;
        element.hidden = !value;
        const valueElement = element.querySelector('span');
        if (valueElement) valueElement.textContent = value || '';
        element.setAttribute('aria-label', value ? `${label}: ${value}` : label);
      };
      updateMeta(sku, option.dataset.sku, 'SKU');
      updateMeta(barcode, option.dataset.barcode, 'Barcode');
      if (wholesalePrice && option.dataset.price) wholesalePrice.textContent = option.dataset.price;
      const salePrice = root.querySelector('[data-product-sale-price]');
      if (salePrice) {
        const current = Number(option.dataset.priceCents);
        const compare = Number(option.dataset.compareCents);
        const onSale = Number.isFinite(current) && Number.isFinite(compare) && compare > current;
        salePrice.classList.toggle('product-price--sale', onSale);
        salePrice.querySelectorAll('[data-product-was], [data-product-now-label], [data-product-discount]').forEach((element) => {
          element.hidden = !onSale;
        });
        const comparePrice = salePrice.querySelector('[data-product-compare-price]');
        if (comparePrice) comparePrice.textContent = option.dataset.comparePrice || '';
        const discount = salePrice.querySelector('[data-product-discount]');
        if (discount && onSale) {
          const percent = Math.round((compare - current) * 100 / compare);
          discount.textContent = discount.dataset.discountFormat.replace('__percent__', String(percent));
        }
      }
      if (stock) stock.textContent = option.dataset.stockLabel || '0';
    });
    const reveals = root.querySelectorAll('[data-product-reveal]');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      reveals.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }), { threshold: .08, rootMargin: '0px 0px -25px' });
    reveals.forEach((item) => observer.observe(item));
  };
  const initialiseAll = (scope = document) => scope.querySelectorAll('[data-product-page]').forEach(initialise);
  document.addEventListener('DOMContentLoaded', () => initialiseAll());
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
